<template>
  <div class="tile__badge">
      <v-badge
        v-if="isActive"
        :content="count"
        overlap
        bordered
        color="black"
      >
        <v-icon color="black" x-large>{{ icon }}</v-icon>
      </v-badge>

      <v-badge
        v-else
        content="-"
        overlap
        bordered
        color="tileIconInactive"
      >
        <v-icon color="tileIconInactive" x-large>{{ icon }}-outline</v-icon>
      </v-badge>
  </div>
</template>

<script>
  export default {
    name: "Badge.vue",
    computed: {
      isActive: function () {
        return this.count > 0
      }
    },
    props: {
      icon: {type: String, default: 'mdi-file-document'},
      count: {type: Number, default: 0}
    }
  }
</script>

<style lang="scss" scoped>
 .tile__badge{
   //text-align: center;
   padding-left: 5px;
 }
</style>
